var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRefresh = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons / refresh-ccw-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.1667 15.729C15.9344 14.4411 17.0833 12.3548 17.0833 10.0002C17.0833 6.08815 13.912 2.91683 9.99999 2.91683H9.58332M9.99999 17.0835C6.08797 17.0835 2.91666 13.9122 2.91666 10.0002C2.91666 7.64555 4.06554 5.55927 5.83332 4.27133M9.16666 18.6668L10.8333 17.0002L9.16666 15.3335M10.8333 4.66683L9.16666 3.00016L10.8333 1.3335",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRefresh, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/refresh.47dfaf49.svg";
export { ForwardRef as ReactComponent };